import React, { Fragment } from 'react';
import { GetHandleProps, GetRailProps, GetTrackProps, SliderItem } from 'react-compound-slider';
import styled from 'styled-components';

import PropTypes from 'prop-types';

const OuterRail = styled.div`
  position: absolute;
  width: 100%;
  height: 8px;
  transform: translate(0%, -50%);
  border-radius: 0px;
  cursor: pointer;
  border: 1px solid white;
  pointer-events: none;
  background-color: rgb(222, 222, 222);
`;

const InnerRail = styled.div`
  position: absolute;
  width: 100%;
  height: 6px;
  transform: translate(0%, -50%);
  border-radius: 0px;
  pointer-events: none;
  background-color: rgb(155, 155, 155);
`;

const HandleValueContainer = styled.div`
  transform: translate(-25%, -75%);
  text-align: center;
  display: inline-block;
`;

const HandleContainer = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  z-index: 5;
  width: 28px;
  height: 42px;
  cursor: pointer;
  background-color: none;
`;

const HandleValue = styled.div`
  color: #ff7300;
  font-size: calc(0.5em + 1vw);
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  span {
    padding-left: 4px;
  }
`;

const HandleIcon = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.3);
  background-color: #FF7203;
`;

const TrackContainer = styled.div`
  position: absolute;
  transform: translate(0%, -50%);
  height: 6px;
  z-index: 1;
  background-color: #FF7203;
  border-radius: 7px;
  cursor: pointer;
`;

const TickValue = styled.div`
  font-size: calc(0.2em + 1vw);
  position: absolute;
  margin-top: 14px;
  text-align: center;
`;

const TickContainer = styled.div`
  position: absolute;
  margin-top: -7px;
  width: 2px;
  height: 14px;
  z-index: 1;
  background-color: white;
`;

export function SliderRail({ getRailProps }: { getRailProps: GetRailProps }) {
  return (
    <Fragment>
      <OuterRail {...getRailProps()} />
      <InnerRail />
    </Fragment>
  );
}

SliderRail.propTypes = {
  getRailProps: PropTypes.func.isRequired,
};

export function Handle({
  domain: [min, max],
  handle: { id, value, percent },
  unit,
  getHandleProps,
}: { domain: number[], handle: SliderItem, unit: string, getHandleProps: GetHandleProps }) {
  return (
    <Fragment>
      <HandleContainer style={{ left: `${percent}%` }} {...getHandleProps(id)}>
        <HandleValueContainer>
          <HandleValue>{value}<span>{unit}</span></HandleValue>
        </HandleValueContainer>
      </HandleContainer>
      <HandleIcon
        role="slider"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        style={{ left: `${percent}%` }}
      />
    </Fragment>
  );
}

Handle.propTypes = {
  domain: PropTypes.array.isRequired,
  handle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getHandleProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

Handle.defaultProps = {
  disabled: false,
};

export function Track({ source, target, getTrackProps }:
  { source: SliderItem, target: SliderItem, getTrackProps: GetTrackProps }) {
  return (
    <TrackContainer
      style={{ left: `${source.percent}%`, width: `${target.percent - source.percent}%` }}
      {...getTrackProps()}
    />
  );
}

Track.propTypes = {
  source: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  target: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getTrackProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

Track.defaultProps = {
  disabled: false,
};

export function Tick({ tick, count, unit }:
  { tick: SliderItem, count: number, format: (d: number) => void, unit: string }) {

  const divider = 2;
  const maxWidthPercent = 100;
  const marginLeft = (maxWidthPercent / count) / divider;

  return (
    <div>
      <TickContainer style={{ left: `${tick.percent}%` }} />
      <TickValue
        style={{
          marginLeft: `${-marginLeft}%`,
          width: `${maxWidthPercent / count}%`,
          left: `${tick.percent}%`,
        }}
      >
        {(tick.value)} {unit}
      </TickValue>
    </div>
  );
}

Tick.propTypes = {
  tick: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  count: PropTypes.number.isRequired
};

Tick.defaultProps = {
  format: (d: number) => d,
};
